"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MsgClientImpl = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _m0 = _interopRequireWildcard(require("protobufjs/minimal"));
var _tx = require("./tx");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MsgClientImpl = /*#__PURE__*/function () {
  function MsgClientImpl(rpc) {
    (0, _classCallCheck2["default"])(this, MsgClientImpl);
    (0, _defineProperty2["default"])(this, "rpc", void 0);
    this.rpc = rpc;
    this.createDenom = this.createDenom.bind(this);
    this.mint = this.mint.bind(this);
    this.burn = this.burn.bind(this);
    this.changeAdmin = this.changeAdmin.bind(this);
  }
  (0, _createClass2["default"])(MsgClientImpl, [{
    key: "createDenom",
    value: function createDenom(request) {
      var data = _tx.MsgCreateDenom.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.tokenfactory.Msg", "CreateDenom", data);
      return promise.then(function (data) {
        return _tx.MsgCreateDenomResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "mint",
    value: function mint(request) {
      var data = _tx.MsgMint.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.tokenfactory.Msg", "Mint", data);
      return promise.then(function (data) {
        return _tx.MsgMintResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "burn",
    value: function burn(request) {
      var data = _tx.MsgBurn.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.tokenfactory.Msg", "Burn", data);
      return promise.then(function (data) {
        return _tx.MsgBurnResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "changeAdmin",
    value: function changeAdmin(request) {
      var data = _tx.MsgChangeAdmin.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.tokenfactory.Msg", "ChangeAdmin", data);
      return promise.then(function (data) {
        return _tx.MsgChangeAdminResponse.decode(new _m0.Reader(data));
      });
    }
  }]);
  return MsgClientImpl;
}();
exports.MsgClientImpl = MsgClientImpl;